import React from 'react';
import { disableAutocompleteProps, getTravellerName, getUserValue } from '../../../../utils';
import { Field } from 'react-final-form';
// import { Select } from '../../../../Passenger/components/Field/Select/Select';
import Input from '../../../../BaseComponents/Input';
import { TravellerFieldEnum } from '@websky/graphql';
import { useTheme } from '../../../../theme';
import { useConfig } from '../../../../context';
import { useTranslation } from 'react-i18next';
const TravellerFields = ({ traveller, loyaltyCardTypes }) => {
    const theme = useTheme('Loyalty').LinkCardsModal;
    const { t } = useTranslation('LinkCardsModal');
    const FFPRegex = useConfig().global.FFPRegex;
    // const iataCode = useConfig().global.companyInfo.iataCode;
    const testFFP = (value) => {
        if (value && !FFPRegex.test(value)) {
            return t('CustomerContactsForm:Please enter a valid FFP');
        }
        else {
            return undefined;
        }
    };
    // const cardTypesList = React.useMemo(() => {
    // 	if (loyaltyCardTypes?.length) {
    // 		return loyaltyCardTypes;
    // 	}
    //
    // 	return [{ key: LoyaltyCardsType.IndividualCard, value: t('Individual loyalty card') }];
    // }, [loyaltyCardTypes]);
    const loyaltyNumber = getUserValue(traveller, TravellerFieldEnum.LoyaltyNumber);
    // const isDisabledCardTypes = iataCode !== 'B2' || !!loyaltyNumber;
    const disabled = !!loyaltyNumber;
    return (React.createElement("div", { className: theme.traveller },
        React.createElement("div", { className: theme.traveller__name }, getTravellerName(traveller)),
        React.createElement("div", { className: theme.traveller__fields },
            React.createElement(Field, { name: `travellers[${traveller.id}].loyaltyCardNumber`, defaultValue: loyaltyNumber, validate: !disabled ? testFFP : undefined, render: ({ input, meta }) => (React.createElement(Input, Object.assign({}, input, { className: theme.traveller__input, error: (meta.error || meta.submitError) && meta.touched && !disabled, helperText: (meta.error || meta.submitError) && meta.touched && !disabled && meta.error, value: !!loyaltyNumber ? loyaltyNumber : input.value, disabled: disabled, label: t('Enter a card number'), FormHelperTextProps: {
                        classes: {
                            root: theme.helperText
                        }
                    } }, disableAutocompleteProps))) }))));
};
export default TravellerFields;
